import { api } from '@/lib/api.js';
import { inFlightDedup } from '@/lib/inFlight.js';
import { pollOpts } from '@/lib/poll.js';

export function getTrafficPattern({ groupBy = 'urgency', filters = {}, stageFilter, poll = false } = {}) {
  const params = new URLSearchParams();
  if (groupBy && groupBy !== 'urgency') params.set('group_by', groupBy);
  for (const [key, val] of Object.entries(filters)) {
    if (val) params.set(`filter[${key}]`, typeof val === 'object' ? val.id || val : val);
  }
  if (stageFilter?.length) params.set('filter[stage]', stageFilter.join(','));
  const qs = params.toString();
  const url = `/api/tracon/command-center/pattern${qs ? '?' + qs : ''}`;
  const dedupKey = `traffic-pattern:${groupBy}:${JSON.stringify(filters)}:${stageFilter?.join(',')}`;
  return inFlightDedup(dedupKey, () => api.get(url, pollOpts(poll)));
}

export function clearTask(taskId, { reason, note } = {}) {
  return api.post(`/api/tracon/command-center/tasks/${taskId}/clear`, { reason, note });
}

export function snoozeTask(taskId, snoozeDays) {
  return api.post(`/api/tracon/command-center/tasks/${taskId}/snooze`, { snooze_days: snoozeDays });
}
